import React from 'react';
import { AutocompleteInput, DateInput,Responsive,SimpleList,NumberField,DateField,Show,ShowButton,List, TextField, SimpleShowLayout,ReferenceInput,Filter,SelectInput,FunctionField } from 'admin-on-rest/lib/mui';

import Datagrid from './Datagrid';
const dateFormatter1 = v => {
  // v is a string of "YYYY-MM-DD" format
  const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
  if (match === null) return;
  const d = new Date(match[1], parseInt(match[2])-1, match[3]);
  if (isNaN(d)) return;
  return d;
};

const dateFormatter = v => {
    // v is a string of "YYYY-MM-DD" format
    const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
    if (match === null) return;
    const d = new Date(match[1], parseInt(match[2], 10) - 1, match[3]);
    if (isNaN(d)) return;
    return d;
  }; 
  const dateParser = v => {
    // v is a `Date` object
    debugger;
    if (!(v instanceof Date) || isNaN(v)) return;
    const pad = '00';
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();
    return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
  };
const dateParser1 = v => {
  // v is a `Date` object
  if (!(v instanceof Date) || isNaN(v)) return;
  const pad = '00';
  const yy = v.getFullYear().toString();
  const mm = ((v.getMonth() + 1).toString());
  const dd = v.getDate().toString();
  return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
};

var minDate=new Date();
minDate.setDate(minDate.getDate()-180);

const HafkadotFilter = (props) => (
    
    <Filter {...props} >
         <ReferenceInput label="בית עסק" source="id" reference="customers" perPage={500} sort={{ field: 'name_heb', order: 'ASC' }} allowEmpty>
         <SelectInput optionText="name_heb" />
            
        </ReferenceInput>
        <DateInput   parse={dateParser} parse={dateParser} locales="he-IL" label="ת.סיום" source="EndDate" options={{
    mode: 'landscape',
    //maxDate: new Date(),
  //minDate:minDate,
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>
      <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת.התחלה" source="StartDate" options={{
    mode: 'landscape',
    //maxDate: new Date(),
  //minDate:minDate,
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>
        
    
    </Filter>
);


const rowStyle = (record) => {
    if (record.commission_ammount <0) return { backgroundColor: '#fdd' };
    
    return {};
};


export const HafkadotList1 = (props) => (
    <div>
    <List title="דף חשבון" perPage={30} {...props}  filters={<HafkadotFilter /> }>
     
      <Responsive
       small={
        
                 <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="deposit_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="rchisha_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type" />


<NumberField label="סכום עסקה" source="schum_iska" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    

    
            <ShowButton />
        </Datagrid>
            }
 medium={

            
    
            
        
          <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="deposit_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="rchisha_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type" />


<NumberField label="סכום עסקה" source="schum_iska" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    
 
    
            <ShowButton />
        </Datagrid>
        
        
 }
         />
  
    </List>
  
    </div>
);


const HafkadotTitle = ({ record }) => {
    return <span>מספר {record ? `"${record.id}"` : ''}</span>;
};

const HafkadotListTitle = ({ lst }) => {
    return <span>דף חשבון</span>;
};


export const HafkadotList = props => (
    <List title="דף חשבון" perPage={30} {...props}  filters={<HafkadotFilter /> }>
        <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }} totalRows="300">
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="deposit_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="rchisha_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type"  />

<FunctionField label="סכום עסקה" source="schum_iska" render={record =>record.schum_iska.toLocaleString(undefined, {
                        style: 'currency',
                        currency: record.currency,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}/>
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    
 
    
            <ShowButton />
        </Datagrid>
        
    </List>
);





const HafkadotStyle = {
  width:120,
    minHeight: 40,
    marginLeft: '2em',
    display: 'inline-block',
    verticalAlign: 'top'
};



export const HafkadotShow = (props) => (

<Show title={<HafkadotTitle />} {...props}>
 <SimpleShowLayout >
  <TextField style={HafkadotStyle}  label="#" source="id" />
<TextField style={HafkadotStyle}  label="מזהה רשת חיצוני" source="external_id" />

<TextField style={HafkadotStyle} label="מספר בית עסק" source="buisiness_id" />
<TextField style={HafkadotStyle} label="מספר כרטיס מלא" source="cc_id" />

<TextField style={HafkadotStyle}  elStyle={{ width: '5em' }} label="מספר שובר" source="shovar_number" />
<TextField style={HafkadotStyle} label="סוג תנועה" source="tnuaa_type" />
<TextField style={HafkadotStyle} label="מקור  תנועה" source="tnuaa_source" />
<DateField style={HafkadotStyle} label="תאריך הפקדה" source="deposit_date.date" />
<DateField style={HafkadotStyle} label="תאריך זיכוי" source="zikui_date.date" />
<TextField style={HafkadotStyle} label="מספר חשבון" source="account_number" />
<TextField style={HafkadotStyle} label="מטבע תנועה" source="tnuaa_currency" />
<TextField style={HafkadotStyle} label="מטבע זיכוי" source="zikui_currency" />
<TextField style={HafkadotStyle} label="אינדיקציה לתשלומים" source="payments_indication" />
<TextField style={HafkadotStyle} label="סכום עסקה  ברוטו תשלומים" source="bruto_iska_tashlumim" />
<TextField style={HafkadotStyle} label="סכום ברוטו לזיכוי " source="zikui_total_bruto" />
<TextField style={HafkadotStyle} label="סכום עמלה" source="commission_ammount" />
<TextField style={HafkadotStyle} label="מעמ עמלה" source="comission_vat" />
<TextField style={HafkadotStyle} label="סכום ההנחה" source="discount_ammount" />
<TextField style={HafkadotStyle} label="סכום זיכוי" source="total_zikui" />
<TextField style={HafkadotStyle} label="מספר תשלום נוכחי" source="current_payment_number" />
<TextField style={HafkadotStyle} label="מספר תשלומים" source="total_payments" />
<TextField style={HafkadotStyle} label="יתרת תשלומים" source="remaining_payments" />
<TextField style={HafkadotStyle} label="סכום ריבית דמי ניכיון" source="total_dme_nikayon_interest" />
<TextField style={HafkadotStyle} label="סכום דמי ניהול " source="total_dme_nihul" />
<TextField style={HafkadotStyle} label="ניקוד ב- pos" source="pos_points" />

<TextField style={HafkadotStyle} label="מספר מסוף" source="masof_number" />
<TextField style={HafkadotStyle} label="תש' ראשון" source="first_payment" />
<TextField style={HafkadotStyle} label="סכום תשלום" source="total_ammount" />
<TextField style={HafkadotStyle} label="מועדון" source="club" />

<TextField style={HafkadotStyle} label="קוד אישור" source="kod_ishur" />
<TextField style={HafkadotStyle} label="קוד מאפיין  עסקה" source="kod_meafyen_iska" />
<TextField style={HafkadotStyle} label="קוד אופי עסקה" source="kod_ofi_iska" />
<TextField style={HafkadotStyle} label="מזהה חד ערכי" source="unique_id" />
<TextField style={HafkadotStyle} label="סכום ביטול" source="bitul_ammount" />
<TextField style={HafkadotStyle} label="סכום עצירה" source="stop_ammount" />
<TextField style={HafkadotStyle} label="מזהה תנועה" source="tnuaa_id" />
<TextField style={HafkadotStyle} label="מהות עסקה" source="mahut_iska" />
<TextField style={HafkadotStyle} label="שער המרה" source="shaar_hamara" />
<TextField style={HafkadotStyle} label="שדה Z" source="z_field" />
<TextField style={HafkadotStyle} label="מזדמנת כ/ל" source="mizdamenet" />
<TextField style={HafkadotStyle} label="סטטוס רשומה 1/2" source="status_reshuma" />
<TextField style={HafkadotStyle} label="שם בית עסק" source="shem_esek" />
<TextField style={HafkadotStyle} label="מספר חשבון" source="mispar_cheshbon" />
<TextField style={HafkadotStyle} label="מזהה תוכנית כאל לקבל יותר" source="mezahe_tochnit_cal_yoter" />
<TextField style={HafkadotStyle} label="סכום הנחת כאל לקבל יותר" source="hanacha_cal_yoter" />
<TextField style={HafkadotStyle} label="אחוז הנחת כאל לקבל יותר" source="ahuz_hanacha_cal_yoter" />
<TextField style={HafkadotStyle} label="Mid Trn ID" source="mid_trn_id" />
<TextField style={HafkadotStyle} label="PSP Trn ID" source="psp_trn_id" />
<TextField style={HafkadotStyle} label="Gateway Trn ID" source="gateway_trn_id" />
<TextField style={HafkadotStyle} label="מזהה בקשת אישור" source="mezahe_bakasha_ishur" />

<TextField style={HafkadotStyle} label="מספר חשבונית" source="mispar_cheshbonit" />
<TextField style={HafkadotStyle} label="מספר משלם" source="mispar_meshalem" />
<TextField style={HafkadotStyle} label="סוג תנועה שבא" source="sug_tnuaa_shva" />
<TextField style={HafkadotStyle} label="סכום מזומן CASHBACK" source="mezuman_schum_cashback" />
<TextField style={HafkadotStyle} label="מזהה עסקה שבא" source="mezahe_iska_shva" />
<TextField style={HafkadotStyle} label="אינדיקציה לתייר" source="tayar_indikazia" />
<TextField style={HafkadotStyle} label="קובץ מקור" source="source_file" />

         </SimpleShowLayout>
    </Show>
);






























// WEBPACK FOOTER //
// ./src/components/Hafkadot/hafkadot.js